import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
const PDPProductDescriptionPlaceholder = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col items-start space-y-5 mt-14 pt-14 border-t border-solid border-gray-light6"><Placeholder type="rect" loading={true} className="!w-full !h-[64px]" /><Placeholder type="text" loading={true} rows={4} className="!w-full" /><Placeholder type="rect" loading={true} className="!w-[178px] !h-[26px]" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PDPProductDescriptionPlaceholder;